export const testIds = {
  loadingSpinnerTestId: "AccountSearchController-loading"
};
export const featureFlags = {
  typeaheadFeatureFlag: "cc-account-search-typeahead"
};
export const searchByAccountLabelText = "Search by Account ID";
